import React, { useState } from 'react'
import './SearchBar.css';
import { Link } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel';

function SearchFavoriteGame({ placeholder, data }) {

  const [filteredData, setFilteredData] = useState([]);
let title;
  const handleFilter = (event) => {
    const searchWord = event.target.value
    const newFilter = data.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([])
    }
    else {
      setFilteredData(newFilter);
    }

  }


  const setFavGame = () =>{

    title = document.getElementById("game").innerHTML;

    localStorage.setItem("favoriteGame", title);

  }
  return (
    <div className="search">
      <div className="searchInputs">
        <input type="search" placeholder={placeholder} onChange={handleFilter} />
      </div>
      {filteredData.length != 0 && (
        <div className="dataResult absolute">
          {filteredData.slice(0, 10).map((value, key) => {
            return <button onClick={setFavGame}><a className="dataItem">
              <p  id="game">{value.title}</p>
            </a></button>

          })}
        </div>
      )}
    </div>
  )
}

export default SearchFavoriteGame
